import React from "react";
import { Step, StepLabel, Stepper, Typography } from "@mui/material";

const STEPS = ["Entity data", "Personal Information", "Payment"];

interface IProps {
    // 0-indexed: which of the 3 steps is the current page.
    activeStep: 0 | 1 | 2;
    // Which of the three flows this is - shown above the stepper since
    // the step names alone ("Entity data", "Payment"...) don't say
    // whether the user is registering, renewing, or transferring an LEI.
    flowName: "Registration" | "Renewal" | "Transfer";
}

// Shown above the H1 on every page of the Register/Renew/Transfer LEI
// flow, so the page itself only needs to say what this one step is
// about (e.g. "Entity data") instead of restating the whole flow name.
export const FlowStepper: React.FC<IProps> = ({ activeStep, flowName }) => (
    <>
        <Typography
            variant="overline"
            sx={{ color: "text.secondary", fontWeight: 600, letterSpacing: 1 }}
        >
            LEI {flowName}
        </Typography>
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3, mt: 0.5 }}>
            {STEPS.map((label) => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    </>
);

export default FlowStepper;
